import React, { useEffect, useMemo, useState } from 'react'
import Step1 from '../Step1/Step1'
import Step2 from '../Step2/Step2'
import Step3 from '../Step3/Step3'
import Step4 from '../Step4/Step4'
import Step5 from '../Step5/Step5'
import Step6 from '../Step6/Step6'
import { BrowserView, MobileView } from 'react-device-detect'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import { Stepper, Step, StepLabel, MobileStepper } from '@mui/material'
import useActivationObject from '../../providers/ActivationObjectProvider/hooks/useActivationObject'
import { WizardStepTypeToNumber } from '../../providers/ActivationObjectProvider/helpers'
import { useHistory } from 'react-router'
import TagManager from 'react-gtm-module'

const Progress = () => {
    const [activeStep, setActiveStep] = useState<number>()
    const { data: activationObject } = useActivationObject()
    const history = useHistory()

    React.useEffect(() => {
        if (activationObject) {
            setActiveStep(WizardStepTypeToNumber(activationObject.wizardStep))
        }
        //else if (isLoaded) window.location.replace('/')
    }, [activationObject, history])

    const handleStepBack = () => {
        TagManager.dataLayer({
            dataLayer: {
                event: 'clickBack',
            },
        })
        setActiveStep((prev) => (prev !== undefined && prev > 0 ? prev - 1 : 0))
    }

    const stepperConfig = useMemo(() => {
        return [
            {
                label: 'Základní informace',
                component: <Step1 onStepBack={handleStepBack}></Step1>,
            },
            {
                label: 'Identifikace objektu',
                component: <Step2 onStepBack={handleStepBack}></Step2>,
            },
            {
                label: 'Kontrola objektu',
                component: <Step3 onStepBack={handleStepBack}></Step3>,
            },
            {
                label: 'Reakce tísňové linky',
                component: <Step4 onStepBack={handleStepBack}></Step4>,
            },
            {
                label: 'Čerpání služeb',
                component: <Step5 onStepBack={handleStepBack}></Step5>,
            },
            {
                label: 'Souhrn',
                component: <Step6 onStepBack={handleStepBack}></Step6>,
            },
        ]
    }, [])

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [activeStep])

    if (!activationObject || activeStep === undefined) return <></>
    return (
        <Box padding={2}>
            <Paper elevation={5}>
                <BrowserView>
                    <Box padding={3}>
                        <Stepper activeStep={activeStep} alternativeLabel>
                            {stepperConfig.map((it, index) => (
                                <Step key={index}>
                                    <StepLabel>{it.label}</StepLabel>
                                </Step>
                            ))}
                        </Stepper>
                    </Box>
                </BrowserView>
                <MobileView>
                    <MobileStepper
                        variant='dots'
                        steps={6}
                        position='static'
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            width: 'fit-content',
                            margin: '0 auto',
                        }}
                        activeStep={activeStep}
                        backButton={undefined}
                        nextButton={undefined}
                    />
                </MobileView>
                {stepperConfig[activeStep].component}
            </Paper>
        </Box>
    )
}

export default Progress
